module.exports = __webpack_public_path__ + "img/zongzhi.0b34261b.png";